<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
      <el-breadcrumb-item>裁判系统</el-breadcrumb-item>
      <el-breadcrumb-item><b style="font-size: 14px;color: #000;">总决选小组赛</b></el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col :span="12"><el-page-header @back="goBack"></el-page-header></el-col>
      <el-col :span="12" align="right"><span class="link-btn" @click="handleToRM">第一季、第二季裁判系统 >></span></el-col>
    </el-row>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="积分赛Round A" name="1">
        <!-- <div class="tab-desc">此裁判系统需配合H5答题使用。（微信小程序答题无需使用裁判系统，由选手主动控制）</div> -->
        <div class="tab-desc">本轮比赛形式为<span class="exam-type">方阵平板</span>。选手自带设备，使用微信小程序作答。</div>
        <div class="tab-desc">1、点击【开始作答】，开始本题倒计时1分钟，倒计时结束后，自动提交答案。按题目顺序依次点击【开始作答】。</div>
        <div class="tab-desc">2、最后一题计时结束后，开始整场比赛最后2分钟倒计时，目的是让选手做最后的检查，以免有漏答的题目。</div>
        <div class="tab-desc">3、最后2分钟倒计时结束后，裁判宣布比赛结束，同时点击【本场比赛结束】，结束本场考试，提交试卷，完成比赛。</div>
        <!-- <div class="tab-desc"><span class="link-btn" @click="copyFn()">点此复制大屏排行榜链接</span></div> -->
      </el-tab-pane>
      <el-tab-pane label="积分赛Round B" name="2">
        <div class="tab-desc">本轮比赛形式为<span class="exam-type">舞台平板</span>。组委会提供设备，选手分组上台答题。</div>
        <div class="tab-desc">1、点击【开始比赛】开始</div>
        <div class="tab-desc">2、每小题发音完成后，点击【开始作答】，大屏开始倒计时</div>
        <div class="tab-desc">3、每小题倒计时结束，点击【结束作答】提交</div>
        <div class="tab-desc">4、如遇现场突发情况，可【暂停计时】或【本题作废】</div><!--和【重新计时】-->
        <div class="tab-desc">5、点击【本场比赛结束】，设置晋级人数（默认10人），生成本轮排名，结束本场比赛。</div>
      </el-tab-pane>
      <el-tab-pane label="冠军赛Round C" name="3">
        <div class="tab-desc">本轮比赛形式为：<span class="exam-type">现场1V1拼字</span>。选手依次上台答题。</div>
        <div class="tab-desc">1、准备就绪点击【开始比赛】按钮，系统自动生成第一轮比赛。</div>
        <div class="tab-desc">2、如遇上一轮比赛设置错误的情况，可点击“比赛回退”按钮回退上一轮比赛。</div>
      </el-tab-pane>
      <el-tab-pane label="复活赛" name="4">
        <div class="tab-desc">本轮答题方式为<span class="exam-type">方阵平板</span>。选手自带设备，使用微信小程序作答。</div>
        <div class="tab-desc">1、点击【开始作答】，开始本题倒计时1分钟，倒计时结束后，自动提交答案。按题目顺序依次点击【开始作答】。</div>
        <div class="tab-desc">2、最后一题计时结束后，开始整场比赛最后2分钟倒计时，目的是让选手做最后的检查，以免有漏答的题目。</div>
        <div class="tab-desc">3、最后2分钟倒计时结束后，裁判宣布比赛结束，同时点击【本场比赛结束】，结束本场考试，提交试卷，完成比赛。</div>
      </el-tab-pane>
    </el-tabs>

    <template v-if="activeName === '1'">
      <GroupFinal1 :season="season" :level="level" @seasonChange="seasonChangeFn" @levelChange="levelChangeFn" ref="groupFinal1"></GroupFinal1>
    </template>
    <template v-if="activeName === '2'">
      <GroupFinal2 :season="season" :level="level" @seasonChange="seasonChangeFn" @levelChange="levelChangeFn" ref="groupFinal2"></GroupFinal2>
    </template>
    <template v-if="activeName === '3'">
      <!-- 小组赛单轮淘汰 -->
      <GroupSingleRound :season="season" :level="level" @seasonChange="seasonChangeFn" @levelChange="levelChangeFn" ref="groupSingleRound" flag="1-C"></GroupSingleRound>
    </template>
    <template v-if="activeName === '4'">
      <GroupFinalRevival :season="season" :level="level" @seasonChange="seasonChangeFn" @levelChange="levelChangeFn" ref="groupFinalRevival"></GroupFinalRevival>
    </template>

  </div>
</template>
<script>
import GroupFinal1 from './groupFinal1.vue'
import GroupFinal2 from './groupFinal2.vue'
import GroupSingleRound from './singleRoundGroup.vue'
import GroupFinalRevival from './groupFinalRevival.vue'

export default {
  components: {
    GroupFinal1,
    GroupFinal2,
    GroupSingleRound,
    GroupFinalRevival
  },
  data () {
    return {
      activeName: '1',
      season: '',
      level: -1
    }
  },
  created () {
    const level = this.$route.query.level
    this.level = level ? Number(level) : 1
    const season = this.$route.query.season
    this.season = season || this.$chnEngStatusCode.defaultSeason

    this.activeName = this.$route.query.round || '1'
    this.handleClick()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    seasonChangeFn (season) {
      this.season = season
    },
    levelChangeFn (level) {
      this.level = level
    },
    handleClick () {
      setTimeout(() => {
        if (this.activeName === '1') {
          this.$refs.groupFinal1.getList()
        } else if (this.activeName === '2') {
          this.$refs.groupFinal2.getGroups()
        } else if (this.activeName === '3') {
          this.$refs.groupSingleRound.getMatchInfo()
        } else if (this.activeName === '4') {
          this.$refs.groupFinalRevival.getList()
        }
      })
    },
    copyFn () {
    },
    handleToRM () {
      this.$router.push({
        path: '/academic_Management/rm?group=1'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.tab-desc{
  font-size: 14px;
  margin-bottom: 4px;
}
.link-btn{
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 20px;
  font-size: 14px;
}
.exam-type{
  color: #409EFF;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  display: inline-block;
}
</style>
